import { BrandMark } from "./BrandMark";
import { cn } from "@/lib/utils";

interface BrandDividerProps {
  className?: string;
  /** Pixel size of the centered mark. */
  size?: number;
}

/**
 * Subtiele section-divider met het OSS beeldmerk in het midden.
 * Beeldmerk tekent zichzelf bij in-view (strak & technisch).
 */
export function BrandDivider({ className, size = 36 }: BrandDividerProps) {
  return (
    <div
      className={cn(
        "container-wide flex items-center gap-6 py-10",
        className
      )}
      aria-hidden="true"
    >
      <span className="h-px flex-1 bg-border" />
      <BrandMark size={size} variant="reveal-in-view" />
      <span className="h-px flex-1 bg-border" />
    </div>
  );
}

export default BrandDivider;
